// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3hamm","selected":"Chip_selected__32R14"};